<template>
  <div>
    {{ rule.config.direction == 'death' ? 'Death cross' : 'Golden cross' }}:
    {{ rule.config.days_ma1 }}-day MA crosses
    {{ rule.config.direction == 'death' ? 'below' : 'above' }} {{ rule.config.days_ma2 }}-day MA
  </div>
</template>

<script>
export default {
  props: {
    rule: { type: Object, required: true }
  }
}
</script>
